import script from "./MultiSelectCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiSelectCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./MultiSelectCheckbox.vue?vue&type=style&index=0&id=1dfbdb14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dfbdb14"]])

export default __exports__